import styled from 'styled-components'

import { mediaIpad, mediaIpadmini, mediaMobile } from './desktop'

export const ProfileStyled = styled.div`
    padding: 50px 50px;
  ${mediaMobile.Mobile`
    padding: 50px 10px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const RunnerStyled = styled.div`
    display: flex;
    background-color: white;
    padding: 40px 200px;
    min-height: 280px;
    border-radius: 30px;
  ${mediaMobile.Mobile`
    flex-direction: column;

    padding: 40px 10px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const DataRunnerStyled = styled.div`
    display: flex;
    // margin-top: -50px;
  ${mediaMobile.Mobile`
    margin-top: 30px;
    
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const DataRunnertwoStyled = styled.div`
    display: flex;
    margin-top: 15px;
  ${mediaMobile.Mobile`
    margin-top: 15px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const ProfileImgStyled = styled.div`
    margin-right: 60px;
    margin-top: 50px;
  ${mediaMobile.Mobile`
    margin: unset; 
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const ProfileNameStyled = styled.div`
    display: flex;
  ${mediaMobile.Mobile`
    justify-content: center;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const ProfileNameBtnStyled = styled.div`
    display: flex;
  ${mediaMobile.Mobile`
    flex-direction: column;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const ProfileNameRunnerStyled = styled.div`
    font-size: 50px;
    font-weight: bold;
    margin-right: 20px;  
  ${mediaMobile.Mobile`
    font-size: 40px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const ProfileIconRunnerStyled = styled.div`
    // width: 100%;
    max-width: 60px;
    margin-top: 20px;
    margin-right: 40px;  
  ${mediaMobile.Mobile`
    font-size: 40px;
    margin-top: unset;
    margin-right: unset;  
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const DataRunnerComponents = styled.div`
    display: flex;
    width: 180px;
    margin-right: 77px;
    align-items: center;
  ${mediaMobile.Mobile`
    margin-right: 15px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const TextRunnerComponents = styled.div`
    font-size: 30px;
    font-weight: bold;
  ${mediaMobile.Mobile`
    font-size: 25px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const BadgesRunnerComponents = styled.div`
    font-size: 40px;
    font-weight: bold;
    font-family: "DB-X-Li";
    margin-right: 20px;
  ${mediaMobile.Mobile`
    font-size: 30px;
    margin-right: 10px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`



// WEBPACK FOOTER //
// ./src/components/styled-components/profileStyled.js